import ExcelJS from 'exceljs';
import type { VersionDetailItem } from '@/utils/types/flavorVersion';
import { exportIdentifier } from './identifier';

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}
function timestamp(now = new Date()): string {
  return (
    String(now.getFullYear()) +
    pad2(now.getMonth() + 1) +
    pad2(now.getDate()) +
    '-' +
    pad2(now.getHours()) +
    pad2(now.getMinutes())
  );
}
function safeName(s: string): string {
  return s.replace(/[^a-z0-9-_]+/gi, '_').slice(0, 64) || 'flask';
}

const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function saveFlaskExcel(args: {
  items: VersionDetailItem[];
  flavorName: string;
  formulaName: string;
}): Promise<void> {
  const aoa: (string | number)[][] = [
    ['Substance Name', 'Identifier', 'Amount', 'Unit'],
    ...args.items.map((r) => [
      r.substanceName,
      exportIdentifier(r),
      r.amountValue == null ? '' : r.amountValue,
      r.amountUnit ?? '',
    ]),
  ];
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Flask');
  ws.addRows(aoa);

  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf as BlobPart], { type: XLSX_MIME });
  const filename = `${safeName(args.flavorName)}_${safeName(args.formulaName)}_${timestamp()}.xlsx`;

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
